import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Author extends Component {
    constructor(props){
        super(props);
        this.state = {
            listItem: [
                {
                    id: 1,
                    icon: 'fa fa-check',
                    title: 'Contribución al aprendizaje en ingeniería y control adaptativo',
                },
                {
                    id: 2,
                    icon: 'fa fa-check',
                    title: 'Diseño basado en demostraciones algebraicas',
                }
            ]
        }
    }
    render() {
        return (
          <section className="author-section section-padding dark-bg-light" id="author">
              <div className="container">
                  <div className="row justify-content-center">
                      <div className="col-lg-6">
                          <div className="section-heading center-heading text-center mb-60">
                              <h3 className="heading-title">Sobre el autor</h3>
                              <p>Este libro  fruto de la experiencia está dedicado a la investigación en el ámbito del control adaptativo, los sistemas dinámicos y las redes neuronales recurrentes.</p>
                          </div>
                      </div>
                  </div>
                  <div className="row justify-content-center">
                      <div className="col-lg-5 col-md-6">
                          <div className="auhtor-img mb-4 mb-lg-0">
                               <img src="assets/images/bg/autor.jpg" alt="César A. López Segura" className="img-fluid" style={{ width: "450px", height: "auto" }} />
                          </div>
                      </div>
                      <div className="col-lg-5 col-md-6">
                          <div className="section-heading mb-0">
                              <h3 className="heading-title">CAL Segura</h3>
                              <p className='lead'>Centrado en el estudio de los sistemas dinámicos, la inteligencia artificial y el aprendizaje adaptativo. Su trayectoria combina la investigación académica con la divulgación de conocimientos prácticos.</p>
                              {/*<p>Con este libro, pone a disposición de estudiantes, profesores y profesionales una guía clara y práctica para comprender los fundamentos del control adaptativo y las redes recurrentes, aplicados a problemas reales.</p>*/}
                          </div>
          
                          <div className="author-desc">
                              <ul className="list-unstyled">
                                  {
                                  this.state.listItem.map((data,i) => (
                                      <li key={i}><i className={data.icon}></i> {data.title}</li>
                                      ))
                                  }
                              </ul>
                              <p>
                                Puedes conectar conmigo en{" "}
                                <a
                                  href="https://www.linkedin.com/in/calopezsegura/"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  onClick={(event) => {
                                    // URL dinámica para desarrollo y producción
                                    const backendUrl =
                                      window.location.hostname === "neuralnetadaptivecontrol.com"
                                        ? "https://controlbook.onrender.com"
                                        : "http://localhost:3000";
                              
                                    // Trackear el click
                                    fetch(`${backendUrl}/clicks`, {
                                      method: "POST",
                                      headers: { "Content-Type": "application/json" },
                                      body: JSON.stringify({
                                        sessionId: "session-" + Math.random().toString(36).substr(2, 9),
                                        elementId: "linkedin-link-es",
                                        pageUrl: window.location.href,
                                        elementType: "link",
                                        userId: "user-react",
                                        coordinates: { x: event.clientX, y: event.clientY },
                                        metadata: {
                                          platform: "LinkedIn",
                                          action: "visit",
                                        },
                                      }),
                                    }).catch((err) => console.error("Error tracking click:", err));
                                  }}
                                >
                                  Linkedin
                                </a>
                              </p>
                          </div>
                      </div>
                  </div>
              </div>
          </section>
        );
    }
}

export default Author;
